import { MutationTree } from 'vuex';
import {EventAttributesState} from "@/store/cdp/event_attributes/types";

export const mutations: MutationTree<EventAttributesState> = {
  setEventAttributes: (state, payload) => {
    state.eventAttributes = payload;
  },
  setEventAttributeItem:(state, payload) => {
    state.eventAttributeItem = payload
  }
}
